/**
 * localStorageのキーはグローバルなため一括管理する
 */
export const localStorageKeys = {
  /**
   * ユーザー情報
   */

  accessToken: 'accessToken',
  loginCompanyContractPlan: 'loginCompanyContractPlan',
  loginCompanyId: 'loginCompanyId',
  loginCompanyName: 'loginCompanyName',
  loginUserLoginId: 'loginUserLoginId', // TODO: ID統合が完了したら削除
  loginUserRumpCustomerMemberId: 'loginUserRumpCustomerMemberId',
  loginUserName: 'loginUserName',
  loginUserPlaceNodes: 'loginUserPlaceNodes',
  loginUserRole: 'loginUserRole',
  loginUserUuid: 'loginUserUuid',
  loginUserIsRumpRealmAdmin: 'loginUserIsRumpRealmAdmin', // bool 値は1 または 0 で保存する
  loginUserIsLobsterEnabled: 'loginUserIsLobsterEnabled', // bool 値は1 または 0 で保存する
  loginUserKioskRollout: 'loginUserKioskRollout', // bool 値は1 または 0 で保存する

  /**
   * その他
   */

  listFilter: 'listFilter', // 一覧系画面の絞り込み条件
  listFilterSchedules: 'listFilterSchedules', // スケジュール一覧画面の絞り込み条件
  preferShinReportList20240321: 'preferShinReportList20240321', // シン・レポート一覧を利用するかどうかの設定
  sortOrderTemplates: 'sortOrderTemplates', // ひな形一覧の並び替えの条件
  sortOrderImproves: 'sortOrderImproves', // カイゼン一覧の並び替えの条件
} as const

/**
 * useListPagination で使用する localStorage キーのプレフィックス一覧。
 * 新しい画面で useListPagination を使い始める際は、ここにプレフィックスを追加する。
 * ログアウト時にこの一覧を使って全ページネーションキーをクリアする。
 *
 * 各プレフィックスに対して `${prefix}Page` と `${prefix}PageSize` のキーが生成される。
 */
export const paginationStorageKeyPrefixes = [
  'userGroups',
  'glossaries',
] as const
